import { dispatcher } from 'dispatcher';
import { prop } from 'ramda';
import { useLocation, useParams } from 'react-router-dom';
import { useMountEffect } from 'js/hooks/useMountEffect';
import { useGameConfigurationSelector, useUserSelector } from 'js/store/hooks';

export const LaunchGame = () => {
    const { gameCode } = useParams();
    const { search, state: { gameLaunchData } = {} } = useLocation();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const isGamesLoaded = useGameConfigurationSelector(prop('isGamesLoaded'));

    useMountEffect((isMounted) => {
        if (!isGamesLoaded || !isMounted()) {
            return;
        }

        const params = new URLSearchParams(search);
        const mode = params.has('real')
            ? parseInt(params.get('real'))
            : isLoggedIn
                ? 1
                : 0;

        dispatcher.dispatch('game:launch', {
            code: gameCode,
            mode,
            container: 'direct-launch-game-url',
            ...gameLaunchData
        });
    }, [search, isLoggedIn, isGamesLoaded, gameCode]);

    return null;
};
